module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0654.bcee2277.jpg";